import * as amplitude from '@amplitude/analytics-browser'

amplitude.init(import.meta.env.VUE_APP_AMPLITUDE_KEY, {
	minIdLength: 1,
	defaultTracking: true
})

export const Events = {
	ChangeLogView: 'Changelog - View',
	WorkflowActivityAnswered: 'Workflow - Activity Answered',
	NotificationClickedProposalObservation: 'Notification - Clicked: Proposta_Observação',
	NotificationClickedProposalStatus: 'Notification - Clicked: Proposta_Status/Situação',
	NotificationClickedPreAnalysisObservation: 'Notification - Clicked: Pré-Análise_Observação',
	NotificationClickedPreAnalysisNewClient: 'Notification - Clicked: Pré-Análise_NovoCliente',
	NotificationView: 'Notification - View',
	NewSimulatorSent: 'Simulator 2.0 - Sent',
	OldSimulatorSent: 'Old Simulator - Sent',
	DashboardFranchiseView: 'Dashboard Franquia - View',
	DashboardCIView: 'Dashboard Crédito Imobiliário - View',
	DashboardRPView: 'Dashboard Ranking Produtividade - View',
	CopyExternalLinkExt: 'copy_external_link_ext',
	CopyExternalLinkInt: 'copy_external_link_int',
	CustomerSatisfactionView: 'Customer Satisfaction - View',
	PartnerClickedUpdateIsolve: 'partner_clicked_update_isolve',
	ButtonFormsItauClicked: 'button_clicked_download_forms_itau',
	ButtonFormsSantanderClicked: 'button_clicked_download_forms_santander',
	ButtonFormsBradescoClicked: 'button_clicked_download_forms_bradesco',
	ButtonFormsCaixaClicked: 'button_clicked_download_forms_CAIXA',
	PreAnalysisDocBuyerClicked: 'button_clicked_detalhe_documentos_comprador',
	ButtonEditColumnsProposalClicked: 'button_clicked_editar_colunas',
	ViewAlertAttachCaixacontract: 'view_alert_attach_caixa_contract',
	ButtonClickedAttachCaixaContract: 'button_clicked_attach_caixa_contract',
	AttachCaixaContract: 'attach_caixa_contract',
	PhoneUpdateModalView: 'Phone Update Modal - View',
	PhoneUpdateCompleted: 'Phone Update - Completed'
}

/**
 * Capture an event to Amplitude
 * @param eventName
 * @param eventProperties
 */
export function CaptureEvent(eventName: string, eventProperties?: any) {
	amplitude.track(eventName, eventProperties)
}

export default amplitude
